import type { ButtonHTMLAttributes } from 'react'
import React from 'react'
import classNames from 'classnames'

export type PillProps = ButtonHTMLAttributes<HTMLElement> & {
  children?: React.ReactNode
  isSelected?: boolean
}

export const Pill = ({
  children,
  isSelected = false,
  className,
  ...props
}: PillProps) => {
  return (
    <button
      type="button"
      className={classNames(
        'font-size-large radius-largest pointer padding-vertical-12 padding-horizontal-16 border-none font-family-system transition outline-none pointer',
        isSelected
          ? 'background-primary background-primary-dark-on-hover white'
          : 'background-shade-50 background-shade-45-on-hover shade-05',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
